import { Component, OnInit, ViewChild } from '@angular/core';

import { User } from '../../models/User';
import { ToastController, AlertController } from '@ionic/angular';

import { AuthService } from '../../providers/auth-service/auth-service';

@Component({
  selector: 'app-profile-page',
  templateUrl: './profile-page.page.html',
  styleUrls: ['./profile-page.page.scss'],
})
export class ProfilePagePage implements OnInit {
  @ViewChild("avatarInput") avatarInput: any

  newName: string = "";
  newPhotoUrl: string = "";
  newMail: string = "";

  newPassword: string = "";
  newPasswordRepeat: string = "";
  validatePassword: string = "";

  loading: boolean = true;
  avatarUploading: boolean = false;
  editMode: boolean = false;
  passwordEditMode: boolean = false;

  systemColorSchema: string = "light";

  constructor(
      public auth: AuthService,
      private toastController: ToastController,
      private alertController: AlertController) {
      this.auth.isReady().then(()=>{
        this.loading = false;
        this.reinit();
      });
  }

  reinit(){
    this.editMode = false;
    this.passwordEditMode = false;
    this.newName = this.auth.currentUser.displayName;
    this.newPhotoUrl = this.auth.currentUser.photoURL;
    this.newMail = this.auth.currentUser.email;
    this.newPassword = "";
    this.newPasswordRepeat = "";
    this.validatePassword = "";
  }

  ngOnInit() {
    // @ts-ignore
    if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
      this.systemColorSchema = "dark";
    }
  }

  enterEditMode(){
    this.editMode = true;
    this.passwordEditMode = false;
  }
  enterPasswordEditMode(){
    this.editMode = false;
    this.passwordEditMode = true;
  }

  cancelChanges(){
    this.editMode = false;
    this.reinit();
  }

  saveChanges(){
    this.loading = true;
    if(this.newName == this.auth.currentUser.displayName
     && this.newPhotoUrl == this.auth.currentUser.photoURL
     && this.newMail == this.auth.currentUser.email){
      // no changes.. Ok.
      this.loading = false;
      return this.cancelChanges();
    }

    // update information
    this.auth.updateUserInformation(this.newName,this.newPhotoUrl).then((res)=>{
      if(this.newMail != this.auth.currentUser.email){
        this.auth.emailLogin(this.auth.currentUser.email,this.validatePassword).then((res)=>{
          setTimeout(() => {
            this.auth.updateUserMail(this.newMail).then((res)=>{
              this.editMode = false;
              this.loading = false;
            }).catch(async(e)=>{
              this.loading = false;
              const toast = await this.toastController.create({
                message: e.message,
                position: 'top',
                cssClass: "toast-error",
                duration: 5000
              });
              toast.present();
            });
          }, 300);
        }).catch(async(e)=>{
          this.loading = false;
          const toast = await this.toastController.create({
            message: e.message,
            position: 'top',
            cssClass: "toast-error",
            duration: 5000
          });
          toast.present();
        });
      } else {
        this.editMode = false;
        this.loading = false;
      }
    });

  }

  doChangePassword(){
    return new Promise(async (resolve,reject) => {
      this.loading = true;

      // matching?
      if(this.newPassword != this.newPasswordRepeat){
        this.loading = false;
        const toast = await this.toastController.create({
          message: "Password and password confirm doesn't match",
          position: 'top',
          cssClass: "toast-error",
          duration: 3000
        });
        toast.present();
        return resolve(false);
      }

      if(this.newPassword.length < 6){
        this.loading = false;
        const toast = await this.toastController.create({
          message: "Password should be at least 6 characters long",
          position: 'top',
          cssClass: "toast-error",
          duration: 3000
        });
        toast.present();
        return resolve(false);
      }

      this.auth.emailLogin(this.auth.currentUser.email,this.validatePassword).then((res)=>{
        setTimeout(() => {
          this.auth.updateUserPassword(this.newPassword).then( (res) => {
            this.auth.emailLogin(this.auth.currentUser.email,this.newPassword).then((res)=>{
              this.loading = false;
              this.reinit();
              resolve(true);
            });
          }).catch(async(e)=>{
            this.loading = false;
            const toast = await this.toastController.create({
              message: e.message,
              position: 'bottom',
              duration: 5000
            });
            toast.present();
            return resolve(false);
          });
        }, 300);
      }).catch(async(e)=>{
        this.loading = false;
        const toast = await this.toastController.create({
          message: e.message,
          position: 'bottom',
          duration: 5000
        });
        toast.present();
        return resolve(false);
      });

    });
  }

  triggerAvatarUpload(): void {
     if (this.avatarInput) this.avatarInput.nativeElement.click()
  }

  avatarUpload(fileEvent){
    this.avatarUploading = true;
    this.auth.uploadAvatar(fileEvent).then((res)=>{
      this.avatarUploading = false;
      // @ts-ignore
      this.newPhotoUrl = res;
    }).catch(async(e)=>{
      this.avatarUploading = false;
      const toast = await this.toastController.create({
        message: e.message,
        position: 'bottom',
        duration: 5000
      });
      toast.present();
    });
  }

  toggleColorSchemeMode(active){
    this.auth.setOption("colorMode",(active ? 'light' : 'dark'));
    // @ts-ignore
    document.body.classList.toggle('dark', !active);
  }
  getColorSchemaMode(){
    let cloudOption = this.auth.getOption('colorMode');
    if(!cloudOption){
      return this.systemColorSchema;
    } else {
      return cloudOption;
    }
  }

  async toggleSupportChat(active){
    this.auth.setOption("disableSupportChat",!active);
    const toast = await this.toastController.create({
      message: "Some changes require page reload",
      position: 'bottom',
      duration: 2000
    });
    toast.present();
  }


  async deleteAccount(){
    const alert = await this.alertController.create({
      header: 'Do you really, REALLY wan\'t to delete your account?',
      message: 'This cannot be reverted. It will also delete all projects where your are the only team member. All data will be deleted. Please confirm with password.',
      inputs: [
             {
               name: 'password',
               type: 'password',
               placeholder: 'Please confirm with your password.'
             },
      ],
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
          handler: () => {
          }
        }, {
          text: 'Delete',
          handler: async (data) => {

            this.auth.emailLogin(this.auth.currentUser.email,data.password).then(async()=>{
              
              const alert = await this.alertController.create({
                  header: 'Something went wrong!',
                  message: 'Please contact the support for account deletion.',
                  buttons: ['Ok']
                });
              await alert.present();
              
              /*this.auth.deleteCurrentUser().then(()=>{

                // @ts-ignore
                window.location.replace("/login");

              }).catch(async (e)=>{

                // @ts-ignore
                window.location.replace("/login");

                const alert = await this.alertController.create({
                    header: 'Something went wrong!',
                    message: 'Please contact the support or try again later.',
                    buttons: ['Ok']
                  });
                await alert.present();
              });*/
            }).catch(async (e)=>{
              console.log(e);
              const alert = await this.alertController.create({
                  header: 'Wrong password entered.',
                  message: e.message,
                  buttons: ['Try again']
                });
              await alert.present();
            });

          }
        }
      ]
    });
    await alert.present();
  }

}
